module.exports = __webpack_public_path__ + "static/img/vid-01.fec3537.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/images/vid-01.png
// module id = ssRL
// module chunks = 1